'use strict';

import PropTypes from 'prop-types';

import React from 'react';
import { connect } from 'react-redux';
import NextEpisode from './NextEpisode.jsx';
import { updateVideoStateNextVideoIsBinge } from '../../../../../actions/videoPage';

const NextEpisodeContainer = (props) => {
    return <NextEpisode {...props} />;
};

NextEpisodeContainer.propTypes = {
    autoPlaySetting: PropTypes.bool,
    onClick: PropTypes.func,
    nextVideoUrl: PropTypes.string.isRequired,
    videoSvtId: PropTypes.string.isRequired,
    nextVideoTitle: PropTypes.string,
    nextVideoPosterImage: PropTypes.string,
};

const mapStateToProps = (state, ownProps) => ({
    ...ownProps,
});

const mapDispatchToProps = (dispatch) => {
    return {
        setNextVideoIsBinge: (isAutoplay) => {
            dispatch(updateVideoStateNextVideoIsBinge(true, isAutoplay));
        },
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(NextEpisodeContainer);
